const MODEL = 'model'
const JSON = 'json'

function id() {
  return {
    [MODEL]: (object) => {
      object.id = object._id
    },
    [JSON]: (object) => {
      object._id = object.id
    },
  }
}

function time(key) {
  return {
    [JSON]: (object) => {
      // Convert empty strings to null values
      object[key] = object[key] !== '' ? object[key] : null
    },
  }
}

function document(key, documentType) {
  return (type, object) => object[key] = map(object[key], documentType, type)
}

const MAPPERS = {

  application: [
    id(),
    document('jobAd', 'jobAd'),
    document('candidates', 'candidate'),
    document('personalQuestions', 'question'),
  ],

  candidate: [
    id(),
    document('application', 'application'),
    document('opening', 'interview'),
    document('personalQuestions', 'question'),
    {
      [MODEL]: (object) => {
        if (typeof object.votes === 'undefined') {
          object.votes = []
        }
      },
    },
  ],

  company: [
    id(),
    document('videos', 'question'),
  ],

  interview: [
    id(),
    time('endTime'),
    document('questions', 'question'),
    {
      [MODEL]: (object) => {
        // Remove introducees from admin list
        if (object.admins) {
          object.admins = object.admins.filter(admin => !admin.introducee)
        }
        object.chosenCandidates = []
      },
    },
  ],

  live: [
    id(),
  ],

  jobAd: [
    id(),
    time('endTime'),
    document('questions', 'question'),
    document('jobOpenings', 'interview'),
  ],

  question: [
    id(),
  ],

  user: [
    id(),
    document('favoriteVideos', 'question'),
  ],
}

function map(from, documentType, type) {
  if (typeof from === 'object') {
    if (Array.isArray(from)) {
      return from.map(item => map(item, documentType, type))
    }
    const to = { ...from }
    MAPPERS[documentType].forEach((mapper) => {
      switch (typeof mapper) {
        case 'object':
          type in mapper ? mapper[type](to) : null
          break
        case 'function':
          mapper(type, to)
          break
      }
    })
    return to
  }
  return from
}

export default {
  mapUserJsonToModel: json => map(json, 'user', MODEL),
  mapUserModelToJson: model => map(model, 'user', JSON),
  mapQuestionJsonToModel: json => map(json, 'question', MODEL),
  mapQuestionModelToJson: model => map(model, 'question', JSON),
  mapCompanyJsonToModel: json => map(json, 'company', MODEL),
  mapCompanyModelToJson: model => map(model, 'company', JSON),
  mapJobAdJsonToModel: json => map(json, 'jobAd', MODEL),
  mapJobAdModelToJson: model => map(model, 'jobAd', JSON),
  mapInterviewJsonToModel: json => map(json, 'interview', MODEL),
  mapInterviewModelToJson: model => map(model, 'interview', JSON),
  mapApplicationJsonToModel: json => map(json, 'application', MODEL),
  mapApplicationModelToJson: model => map(model, 'application', JSON),
  mapCandidateJsonToModel: json => map(json, 'candidate', MODEL),
  mapCandidateModelToJson: model => map(model, 'candidate', JSON),
  mapLiveJsonToModel: json => map(json, 'live', MODEL),
  mapLiveModelToJson: model => map(model, 'live', JSON),

}
